import Typography from 'antd/es/typography/Typography'
import { clearIdTokens } from 'services/authAxios'
import { LocalAuthStorageKey } from 'types'

import Button from 'components/atoms/Button'
import Modal from 'components/atoms/Modal'

export default function OverCountVerifyEmailModal() {
  const handleOk = () => {
    localStorage.removeItem(LocalAuthStorageKey.PREVIOUS_SESSION_EXPIRED_PATH)
    clearIdTokens()
    localStorage.removeItem('last_activity')
    window.location.replace('/signin')
  }

  return (
    <Modal centered footer={null}>
      <Typography className="text-center">
        メールアドレスの入力回数が上限に達しました。再度ログインしてください。
      </Typography>
      <div className="flex justify-center items-center py-4">
        <Button
          type="primary"
          onClick={handleOk}
          sizing="w-[250px] rounded-lg h-[60px]"
        >
          ログイン画面に戻る
        </Button>
      </div>
    </Modal>
  )
}
